import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'
import { useDispatch, useSelector, type TypedUseSelectorHook } from 'react-redux'
import { baseApi } from '../api/baseApi'
import { ui } from './uiSlice'
import { session } from './sessionSlice'
import { session as tokens } from '../api/client'

export const makeStore = () => {
  const store = configureStore({
    reducer: { [baseApi.reducerPath]: baseApi.reducer, ui: ui.reducer, session: session.reducer },
    middleware: gdm => gdm().concat(baseApi.middleware),
  })
  setupListeners(store.dispatch)
  // Signing out (logout or a refresh the server refused) drops every snapshot.
  tokens.subscribe(signedIn => {
    store.dispatch(session.actions.signedIn(signedIn))
    if (!signedIn) store.dispatch(baseApi.util.resetApiState())
  })
  return store
}

export const store = makeStore()

export type AppStore = ReturnType<typeof makeStore>
export type RootState = ReturnType<AppStore['getState']>
export type AppDispatch = AppStore['dispatch']
export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
